export default "__VITE_ASSET___XO$J6rM__"